<div class="publishing-table-wrapper" aria-live="polite">
  <table class="publishing-table">
    <thead>
      <tr>
        <th class="publishing-table__th publishing-table__th--checkbox" aria-label="Select"></th>
        <th class="publishing-table__th publishing-table__th--preview">Preview</th>
        <th class="publishing-table__th publishing-table__th--title">Title</th>
        <th class="publishing-table__th publishing-table__th--platform">Platform</th>
        <th class="publishing-table__th publishing-table__th--destination">Destination</th>
        <th class="publishing-table__th publishing-table__th--date">Date</th>
        <th class="publishing-table__th publishing-table__th--status">Status</th>
        <th class="publishing-table__th publishing-table__th--actions" aria-label="Actions"></th>
      </tr>
    </thead>
    <tbody>
      @for (event of events; track event.id) {
        <tr
          evrideo-publishing-event-row
          [event]="event"
          [selected]="isSelected(event.id)"
          [selectionDisabled]="selectionDisabled"
          (selectionChange)="onSelectionChange(event, $event)"
          (cancelled)="onCancelled()"
        ></tr>
      } @empty {
        <tr class="publishing-table__empty-row">
          <td class="publishing-table__empty" colspan="8">
            <p>No distribution events match your criteria</p>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
